// Achievement definitions and checker
import { getStats } from './store';
import { getItem, setItem } from '../storage/db';

export interface Achievement {
  id: string;
  name: string;
  description: string;
  icon: string;
  check: (stats: Awaited<ReturnType<typeof getStats>>) => boolean;
}

export const ACHIEVEMENTS: Achievement[] = [
  {
    id: 'first_win',
    name: 'First Win',
    description: 'Menangkan permainan pertamamu!',
    icon: '⭐',
    check: (stats) => stats.games.some(g => g.result === 'win'),
  },
  {
    id: 'checkmate_master',
    name: 'Checkmate Master',
    description: 'Menangkan 5 permainan dengan checkmate',
    icon: '♛',
    check: (stats) => stats.games.filter(g => g.result === 'win').length >= 5,
  },
  {
    id: 'ten_wins',
    name: '10 Wins',
    description: 'Menangkan 10 permainan',
    icon: '🏅',
    check: (stats) => stats.games.filter(g => g.result === 'win').length >= 10,
  },
  {
    id: 'hundred_wins',
    name: '100 Wins',
    description: 'Menangkan 100 permainan',
    icon: '🏆',
    check: (stats) => stats.games.filter(g => g.result === 'win').length >= 100,
  },
  {
    id: 'puzzle_master',
    name: 'Puzzle Master',
    description: 'Selesaikan 50 puzzle',
    icon: '🧩',
    check: (stats) => stats.puzzles.filter(p => p.solved).length >= 50,
  },
  {
    id: 'no_blunder',
    name: 'No Blunder Game',
    description: 'Menangkan permainan tanpa blunder (Medium+)',
    icon: '🎯',
    check: (stats) => stats.games.some(g => g.result === 'win' && g.difficulty !== 'easy'),
  },
];

const UNLOCKED_KEY = 'chesskid_achievements';

export async function getUnlockedAchievements(): Promise<string[]> {
  return (await getItem<string[]>(UNLOCKED_KEY)) ?? [];
}

export async function checkAchievements(): Promise<Achievement[]> {
  const stats = await getStats();
  const unlocked = await getUnlockedAchievements();
  const newlyUnlocked: Achievement[] = [];

  for (const achievement of ACHIEVEMENTS) {
    if (!unlocked.includes(achievement.id) && achievement.check(stats)) {
      unlocked.push(achievement.id);
      newlyUnlocked.push(achievement);
    }
  }

  if (newlyUnlocked.length > 0) {
    await setItem(UNLOCKED_KEY, unlocked);
  }

  return newlyUnlocked;
}
